// /finance's To do, Cash and Clients on jobs (finance-real, the user 2026-10-23), read as useLineJobs' reads are: under
// financeKeys.all, so every finance write refetches them and a job, invoice or claim changed in a drawer reads on these
// tabs at once. Each read calls main's routes (GET /agency/todo, /agency/cash, /agency/clients[/:id]) in their shapes on
// jobs (finance consolidation S8, S9).
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { CashDays, JobClientsShow } from "../types";
import { financeKeys } from "./financeQuery";
import { agencyService } from "../services/agencyService";

export const agencyTabKeys = {
  toDo: () => [...financeKeys.all, "jobs-todo"] as const,
  cash: (days: CashDays) => [...financeKeys.all, "jobs-cash", days] as const,
  clients: (show: JobClientsShow) => [...financeKeys.all, "jobs-clients", show] as const,
  client: (clientId: string) => [...financeKeys.all, "jobs-client", clientId] as const,
};

export const useJobsToDo = () => useQuery({ queryKey: agencyTabKeys.toDo(), queryFn: agencyService.jobsToDo });

/** Keeps the last range's view on screen while the next one loads, as main's Cash does. */
export const useJobsCashView = (days: CashDays) => useQuery({ queryKey: agencyTabKeys.cash(days), queryFn: () => agencyService.cash(days), placeholderData: keepPreviousData });

/** A status tab's clients, every tab's count and the tab's footer. Keeps the last tab's rows on screen while the next one
 * loads, so the table never blanks (DD-042), as main's Clients does. */
export const useJobClients = (show: JobClientsShow) =>
  useQuery({ queryKey: agencyTabKeys.clients(show), queryFn: () => agencyService.jobClients(show), placeholderData: keepPreviousData });

/** One client's row, for its drawer's strip. */
export const useJobClient = (clientId: string) => useQuery({ queryKey: agencyTabKeys.client(clientId), queryFn: () => agencyService.clientRow(clientId) });
